// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .close-modal {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      top: 10px;
    }
  }
  .modal-heading {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      text-align: center;
      padding: 16px;
      border-bottom: 1px solid #d8d8d8;
      margin: 0px 12px;
      font-weight: 700;
      font-size: 16px;
    }
  }
  div.TCPModal__InnerContent {
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
    max-width: 750px;
    min-height: 230px;
    max-height: 70vh;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXL_1};
    overflow: auto;
    background-color: #fff;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      top: initial;
      max-height: 80vh;
      height: initial;
      min-height: 190px;
      left: initial;
      transform: inherit;
      bottom: 0;
      padding: 0 0 27px 0;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .message-container {
    ${(props) =>
      props.globalError ? ` background-color: #c8102e; padding: 12px;` : 'padding: 0px 12px;'}
    display: flex;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => !props.globalError && 'padding: 0px 5px;padding-bottom: 5px;'}
    }
  }

  .disclaimer-text-style {
    color: #c8102e;
    font-family: Nunito;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    width: 90%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 16px;
      width: 100%;
      font-size: 14px;
      margin-top: 0px;
    }
  }
  .disclaimer-text-container {
    display: flex;
    flex-direction: column;
    margin-top: 65px;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 0px 16px;
      margin-top: 0px;
    }
  }
  .outer-cont {
    display: inline-block;
    background-color: white;
    padding: 5px;
    ${(props) => props.globalError && ` color: #c8102e;`}
    border-radius: 50%;
    width: 15px;
    height: 15px;
    text-align: center;
    margin-right: 8px;
    font-size: 13px;
    font-weight: 700;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 12px;
      height: 12px;
      font-size: 10px;
    }
  }
  .title-text-style {
    color: ${(props) => (props.globalError ? 'white' : `#c8102e;`)};
    font-size: 15px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 13px;
    }
  }
  .subtitle-text-style {
    color: ${(props) => (props.globalError ? 'white' : `#c8102e;`)};
    font-size: ${(props) => (props.globalError ? '15px' : `13px`)};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }
  .info-icon-wrapper {
    margin-top: 3px;
    display: flex;
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }
  .footer-message-container {
    display: flex;
  }

  .keep-shopping-text {
    color: ${(props) => props.theme.brandSpecificStyles.KEEP_SHOPPING_TEXT.COLOR};
  }
  .redesigned-keep-shopping {
    width: 50%;
    border-radius: 6px;
    margin-top: 32px;
    background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 90%;
      position: absolute;
      bottom: 0;
      margin-bottom: 18px;
    }
  }
  .redesigned-keep-shopping:hover {
    background-color: ${(props) => props.theme.brandSpecificStyles.RECOM_QVMODAL_BUTTON.BGCOLOR};
  }
`;

export default styles;
